import { Inject, Injectable } from '@angular/core';
import {
    ActionType,
    EventType,
    ILoggerClientService,
    LOGGER_CLIENT_SERVICE_IMPL,
    ModalService,
    OrderStateEventLog,
} from 'shared';
import { CollectingStatesService } from './collecting-states.service';
import { IsWrappingService } from 'dm-src/services/is-wrapping/is-wrapping.service';
import { NativeBarcodeReaderService } from 'dm-src/services/native-barcode-reader/native-barcode-reader.service';
import { IosAndAndroidNatvieFunctionsService } from 'dm-src/services/ios-and-android-natvie-functions/ios-and-android-natvie-functions.service';

export type ProductIdentifyAction = 'barcode' | 'sku';

@Injectable({
    providedIn: 'root',
})
export class ProductIdentifyService {
    constructor(
        private _states: CollectingStatesService,
        @Inject(LOGGER_CLIENT_SERVICE_IMPL)
        private _loggerClientService: ILoggerClientService,
        private _modalService: ModalService,
        private _isWrappingService: IsWrappingService,
        private _nativeBarcodeReaderService: NativeBarcodeReaderService,
        private _iosAndAndroidNatvieFunctionsService: IosAndAndroidNatvieFunctionsService
    ) {}

    public pendingAction: ProductIdentifyAction | null = null;

    public openOrderSelectFor(action: ProductIdentifyAction): void {
        this.pendingAction = action;
        this._modalService.setModalVisibility(true, 'product-identify-modal');
    }

    public run(action: ProductIdentifyAction): void {
        if (action === 'barcode') {
            this.openBarcodeReader();
        } else {
            this.openManualSKUCheck();
        }
    }

    public openBarcodeReader(): void {
        if (window.ReactNativeWebView) {
            this._iosAndAndroidNatvieFunctionsService.openBarcodeReader();
        } else if (this._isWrappingService.isWrapping()) {
            this._iosAndAndroidNatvieFunctionsService.openBarcodeReader();
            this._nativeBarcodeReaderService.initBarcodeReading();
        } else {
            this._states.setBarcodeReaderModalVisible(true);
        }

        this.logButtonClick(
            this._states.replaceableOrderItem != null
                ? ActionType.SearchOfflineProductForReplacedOrderItemByGTINButtonClicked
                : ActionType.SearchOfflineProductForOrderItemByGTINButtonClicked
        );
    }

    public openManualSKUCheck(): void {
        this._modalService.setModalVisibility(true, 'manual-sku-check-modal');

        this.logButtonClick(
            this._states.replaceableOrderItem != null
                ? ActionType.SearchOfflineProductForReplacedOrderItemBySKUButtonClicked
                : ActionType.SearchOfflineProductForOrderItemBySKUButtonClicked
        );
    }

    private logButtonClick(actionType: ActionType): void {
        var orderStateEventLog = new OrderStateEventLog();

        orderStateEventLog.eventType = EventType.OrderItemStateChanged;
        orderStateEventLog.actionType = actionType;
        orderStateEventLog.fromStateJson = null;
        orderStateEventLog.toStateJson = null;
        orderStateEventLog.orderID = this._states.orderID;
        orderStateEventLog.orderCode = this._states.orderCode;

        this._loggerClientService.addOrderStateEventLog(orderStateEventLog).subscribe();
    }
}
